
import { Component, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";

import GetRelativeRouteNameMixin from '@/mixins/route/GetRelativeRouteNameMixin.vue';

import CardBodyItem from "@/components/card/CardBodyItem.vue";
import Card from "@/components/card/Card.vue";
import Chip from "@/components/filters/Chip.vue";
import TableAvatar from "@/components/table/TableAvatar.vue";
import UiButton from "@/components/button/ui-button.vue";
import ApplyButton from "@/components/jobboard/ApplyButton.vue";

import RouteNames from "@/entities/RouteNames";
import { Application, Posting } from "@/generated/graphql";
import getLocationInfo from "@/helpers/locations/getLocationInfo";
import ChipWithLinkData from "@/types/ChipWithLinkData";
import PinIcon from "../icons/PinIcon.vue";
import Calendar from "../icons/calendar.vue";
import CompanyIcon from "../icons/CompanyIcon.vue";
import LocationIcon from "@/components/icons/LocationIconNew.vue";
import PostingCard from "../recruitings/postingComponents/PostingCard.vue";
import ItemsRenderer from "../ItemsRenderer.vue";
import UserIcon from "@/components/icons/UserFill.vue";




@Component({
  components: {
    CardBodyItem,
    ApplyButton,
    UiButton,
    ItemsRenderer,
    Chip,
    Card,
    TableAvatar,
    PinIcon,
    Calendar,
    UserIcon,
    CompanyIcon,
    LocationIcon,
    PostingCard


  }
})
export default class PostingCardRecruit extends mixins(GetRelativeRouteNameMixin) {
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: Object, required: true }) readonly posting!: Posting;
  @Prop({ type: Boolean, default: false }) readonly isMarketplace!: boolean;

  routes = RouteNames;

  applicationExists = false;
handleToggler(isOn) {
}
get getNameClasses(){
  const arr = (this.posting.job_title || '').split(' ')
  const isGreater = arr.find(a => a.length >= 50);

return {
'custom_header_class': isGreater
}
}
  get postingDetailsRouteName(): string {
    return this.getRelativeRouteName(RouteNames.JOBBOARD_POSTING);
  }

  get companyInitials(): string | undefined {
    const name = this.posting.company?.business_name;
    if (!name) {
      return undefined;
    }

    return name[0];
  }

  get type(): string | undefined {
    return this.posting.employment_type || undefined;
  }

  get location(): string {
    return getLocationInfo(this.posting);
  }

  get applicationId(): string | undefined {
    return this.application?.id;
  }

  get isApplicationCancelled(): boolean {
    return Boolean(this.application?.is_cancelled);
  }

  get jobDuration(): string | undefined {
    const { duration } = this.posting;
    if (!duration) {
      return 'n/a';
    }

    const weeks = Math.floor(duration / 7);
    const days = duration % 7;

    const weeksVal = this.formatDateItem('week', weeks);
    const daysVal = this.formatDateItem('day', days);

    return `${weeksVal} ${daysVal}`;
  }

  @Watch('application', { immediate: true })
  postingUpdated() {
    this.applicationExists = Boolean(this.application);
  }

  get application(): Application | undefined {
    if (!this.posting?.applications?.length) {
      return undefined;
    }
    return this.posting.applications[0];
  }

  formatDateItem(unitName: string, value: number): string {
    if (!value) {
      return '';
    }
    if (value !== 1) {
      unitName += 's';
    }

    return `${value} ${unitName}`;
  }

  get skills(): any[] {
    if (this.posting.skills?.length) {
      return this.posting.skills.reduce((acc: any[], skill) => {
        if (skill.skill.name) {
          acc.push({ name: skill.skill.name, id: skill.id });
        }
        return acc;
      }, []);
    }
    return [];
  }

  get industries(): any[] {
    if (this.posting.industries?.length) {
      return this.posting.industries.reduce((acc: any[], { industry }) => {
        if (industry.name) {
          acc.push({ name: industry.name, id: industry.id });
        }
        return acc;
      }, []);
    }
    return [];
  }


  get skillss(): ChipWithLinkData[] {
    let skills = this.posting.skills.map(({ skill }) => skill);
    const skillss = skills.reduce((filtered, skill) => {
      let chipWithLinkData: ChipWithLinkData = {
        variant: "blue",
        chipLink: this.navigateToDetails,
        chipData: { id: skill.id.toString(), name: skill.name },
        avatar: "",
        chipText: ""
      };
      filtered.push(chipWithLinkData);
      return filtered;
    }, []);
    // skills.sort((a, b) => a.variant.localeCompare(b.variant));
    return skillss;
  }

  get industriess(): ChipWithLinkData[] {
    let industries = this.posting.industries.map(({ industry }) => industry);
    const industriess = industries.reduce((filtered, industry) => {
      let chipWithLinkData: ChipWithLinkData = {
        variant: "blue",
        chipLink: this.navigateToDetails,
        chipData: { id: industry.id.toString(), name: industry.name },
        avatar: "",
        chipText: ""
      };
      filtered.push(chipWithLinkData);
      return filtered;
    }, []);
    // skills.sort((a, b) => a.variant.localeCompare(b.variant));
    return industriess;
  }

  get navigateToDetails(): Object {
    return {
      name: RouteNames.JOBBOARD_POSTING,
      params: { id: this.posting.id },
    }
  }
   get getLocationClasses(){
const location = this.location
  const arr = (location || '').split(' ')
  const isGreater = arr.find(a => a.length >= 50);

return {
'custom_header_class': isGreater
}
  }
}
